__turbopack_context__.v({
  "carousel": "learn-hero-carousel-module-scss-module__pqgQqG__carousel",
  "carousel-arrows": "learn-hero-carousel-module-scss-module__pqgQqG__carousel-arrows",
  "carousel-graphics": "learn-hero-carousel-module-scss-module__pqgQqG__carousel-graphics",
  "carousel-header": "learn-hero-carousel-module-scss-module__pqgQqG__carousel-header",
  "carousel-inner": "learn-hero-carousel-module-scss-module__pqgQqG__carousel-inner",
  "carousel-wrapper": "learn-hero-carousel-module-scss-module__pqgQqG__carousel-wrapper",
});
